import { FC, ChangeEvent } from 'react';
import { DropdownWithLabel } from '@blueprint/dropdown';
import { useDispatch, useSelector } from 'react-redux';

import { updateFilter, radiusSelector } from '@zoopla/redux-reducer-filters';
import { SelectRadiusOptions } from '../../../search/common/SelectRadiusOptions';
import {
    FilterWrapper,
    RadiusDropdownWrapper
} from './SearchInitiationMobile.styles';

export const SelectRadius: FC = () => {
    const reduxDispatch = useDispatch();
    const { selectedValue, options } = useSelector(radiusSelector);

    const onRadiusChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('radius', evt.currentTarget.value));
    };
    const radiusLabel = 'Radius';

    return (
        <FilterWrapper>
            <RadiusDropdownWrapper>
                <DropdownWithLabel
                    id="modal-radius-filter"
                    data-testid="mobile_radius_filter-select"
                    onChange={onRadiusChange}
                    value={selectedValue}
                    label={radiusLabel}
                    hasBorderRadius
                >
                    {options.length ? (
                        <SelectRadiusOptions
                            keyPrefix="modal"
                            options={options}
                        />
                    ) : null}
                </DropdownWithLabel>
            </RadiusDropdownWrapper>
        </FilterWrapper>
    );
};
